<template>
    <div class="loop">
        <Title firstName="回路监测" lastName="LOOP MONITORING" />
        <div class="content">
            <div class="tab" >
                <p @click="tabList" >{{loopName}} <i class="el-icon-arrow-down"></i></p>
            </div>
            <div class="list" v-show="showList">
                <SelectList :selectList="loopList" @tabTitle="tabTitle" keyk="id" keyval="value"/>
            </div>
            <div class="loopTable">
                <table>
                    <tr>
                        <td></td>
                        <td>A相</td>
                        <td>B相</td>
                        <td>C相</td>
                        <td>总</td>
                    </tr>
                    <tr>
                        <td>电流(A)</td>
                        <td>{{isNaN(Number(mqtt[loopUrl +'/Ia']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Ia']).toFixed(2)}}</td>
                        <td>{{isNaN(Number(mqtt[loopUrl +'/Ib']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Ib']).toFixed(2)}}</td>
                        <td>{{isNaN(Number(mqtt[loopUrl +'/Ic']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Ic']).toFixed(2)}}</td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>电压(V)</td>
                        <td>{{isNaN(Number(mqtt[loopUrl +'/Ua']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Ua']).toFixed(2)}}</td>
                        <td>{{isNaN(Number(mqtt[loopUrl +'/Ub']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Ub']).toFixed(2)}}</td>
                        <td>{{isNaN(Number(mqtt[loopUrl +'/Uc']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Uc']).toFixed(2)}}</td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>功率因数</td>
                        <td>{{isNaN(Number(mqtt[loopUrl +'/PFa']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/PFa']).toFixed(2)}}</td>
                        <td>{{isNaN(Number(mqtt[loopUrl +'/PFb']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/PFb']).toFixed(2)}}</td>
                        <td>{{isNaN(Number(mqtt[loopUrl +'/PFc']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/PFc']).toFixed(2)}}</td>
                        <td>{{isNaN(Number(mqtt[loopUrl +'/PF']).toFixed(2) )? '--' :Number(mqtt[loopUrl +'/PF']).toFixed(2) }}</td>
                    </tr>
                </table>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const Title = () => import('../../components/title/Title')
const SelectList = () => import('../../components/title/selectList')

import { GetAllLoops } from '../../components/Request'
export default {
    data(){
        return {
            isShow:true,
            loopName:'T1',
            loopUrl:'',
            showList:false,
            loopList:[]
        }
    },
    watch: {
    },
    components:{
        Title,SelectList
    },
    computed:{
        ...mapState({mqtt:'MQTTObj'})
    },
    mounted(){
        this.getAreaLoops()
    },
    methods:{
        tabList(){
             this.showList = !this.showList
        },
        tabTitle(loop){
            console.log(loop);
            this.loopName = loop.value
            this.loopUrl = loop.loop
            this.showList = false
        },
        // 获取区域的所有回路
        async getAreaLoops(){
            let data = {
                areaId :this.$store.state.siteId
            }
            // let res = await GetAllLoops(data)
            let res = await this.$http.areaLoops(data)
            console.log(res);
            let loops = res.data.data.loops
            loops.forEach((item,index) =>{
                let obj = {
                    id:item.loopId,
                    value:item.loopName,
                    loop:item.loopUrl.substr(item.loopUrl.indexOf('/') +1)
                }
                this.loopList.push(obj)
            })
            this.tabTitle(this.loopList[0])
        }
    }
}
</script>

<style lang="less" scoped>
    .loop{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 37.8vh;
        right: 1vw;

        .content{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .tab{
                height: 3.3vh;
                p{
                    position: absolute;
                    right: 1vh;
                    top: 1vh;
                    font-size: 14rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    cursor: pointer;
                }
            }

            .list{
                height: 10.5vh;
                width: 100%;
                position: absolute;
                left: 0;
                top: 3.5vh;
                z-index: 11;
            }

            .loopTable{
                height: 20.7vh;
                table{
                    width: 100%;
                    height: 100%;
                    border-collapse: collapse;
                    tr{
                        width: 100%;
                        height: 5vh;
                        line-height: 5vh;
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                        td{
                            text-align: center;
                            width: 20%;
                        }
                    }
                    tr:nth-child(odd){
                        background-color: rgba(164,209,255, 0.12);
                    }
                    tr{
                        td:nth-child(even){
                            background-color: rgba(164,209,255, 0.12);
                        }
                    }
                    tr:nth-child(2),tr:nth-child(3),tr:nth-child(4){
                        td:nth-child(2),td:nth-child(3),td:nth-child(4),td:nth-child(5){
                            font-size: 18rem;
                            font-family: zcoolqingkehuangyouti;
                            font-weight: 400;
                            color: #00DEFF;
                        }
                    }
                }
            }
            
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>